<style>

/* body {
	 background-color: #3498db;
	 -webkit-font-smoothing: antialiased;
	 -moz-osx-font-smoothing: grayscale;
	 text-rendering: optimizeLegibility;
} */

.blank-page{
  background-color: #fff;
  margin-right: -12px;
  margin-top: 10px;
  padding: 10px;
  border: 5px solid #9ccad4;
  border-radius: 10px;
  height: 370px;
  justify-content: center; /* center horizontally */
  align-items: center;
  display: flex;
  flex-direction: column;
}

.message-side{
  padding-right: 10px;
  padding-left: 5px;
}

.left-message{
  display: flex; 
  justify-content: start;
  text-align: left;
  font-size: 10px;
  padding: 3px;
}

.right-message{
  display: flex;
  justify-content: end;
  text-align: right;
  font-size: 10px;
  padding: 3px;
}

.chat-bubble--left {
  background: #464646;
  color: #fff;
  padding: 10px;
  position: relative;
  max-width: 60%;
  border-radius: 12px 12px 12px 0;
  text-align: initial;
  word-wrap: break-word;
}

.chat-bubble--right {
  background-color: rgb(0, 164, 189);
  color: #fff;
  padding: 10px;
  position: relative; 
  max-width: 60%;
  border-radius: 12px 12px 0 12px;
  text-align: initial;
  word-wrap: break-word;
}

.msg-time--left{
  color: rgb(255, 255, 255);
  font-size: 6px;
  right: 3px;
  bottom: -6px;
  position: relative;
}

.msg-time--right{
  color: rgb(0 0 0);
  font-size: 6px;
  left: 3px;
  bottom: -6px;
  position: relative;
  text-align: right;
}

.scrollbar {
  border-style: solid;
  border-width: 1px;
  border-color: #a0e4f254;
  background-color: #fff;
  margin-right: -12px;
  padding: 3px;
  margin-bottom: 10px;
  height: 270px;
  overflow-y: auto;
  overflow-x: hidden;
}
       
.scrollbar::-webkit-scrollbar {
   width: 8px;
}

.scrollbar::-webkit-scrollbar-track {
  border-radius: 8px;
    background-color: #d1e7ee;
    border: 1px solid #cacaca;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px;
  border-color: black;
}

.containerchat {
  bottom: 100px;
  right: 50px;
  width: 650px;
  height: 400px;
  background: #365462;
  border-radius: 10px;
}

.profile-image {
  margin-left: 12px;
  width: 30px;
  height: 30px;
}

.settings-tray {
  background: #bbeef6c4;
  display: flex;
  margin-right: -12px;
  color: grey;
  vertical-align: middle;
  margin-top: 10px;
  padding: 10px;
  border-radius: 10px 10px 0px 0px;
  
}

h6 {
  vertical-align: middle;
  margin-left: 10px;
  margin-top: 1px;
  margin-bottom: 0;
}

.type_msg{
  float: left;
  background-color: #bbeef6c4 !important;
  width: 80%;
  border:10px !important;
  color:rgb(0, 0, 0) !important;
  height: 50px !important;
  overflow-y: auto;
  border-radius: 0px 0px 00px 10px;
  margin-left: 0px;
}

.type_msg:focus{
  box-shadow:none !important;
  outline:20px !important;
}

.type_msg::-webkit-scrollbar {
  display: none;
}

textarea {
  /* margin-top: -10px;
  margin-left: 15px; */
  border: none;
  border-radius: 30px;
  width: 80%;
}

textarea::placeholder {
  color: #e3e3e3;
  font-weight: 300;
  margin-left: 20px;
}

textarea:focus {
  outline: none;
}

.send_button{
  width: 25%;
  float: right;
  font-size: 12px;
  background-color: #00a4bd;
  border-radius: 0px 0px 10px 0px;
  color: white;
  font-weight: bold;
  height: 50px;
  margin-right: -12px;
  margin-top: -50px;
}

.noti{
  position: absolute;
  background-color: #246fc0;
  color: white;
  right: 10%;
  width: 20px;
  height: 20px;
  float: right;
  text-align: center;
  font-size: 15px;
}

.scroll-item{
  border-style: solid;
  border-width: 1px;
  border-color: #a0e4f254;
  background-color: #fff;
  padding: 3px;
  height: 320px;
  border-radius: 0px 0px 10px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.menu-item{ 
  display: flex;
  background: #fff;
  transition: 0.3s ease;
  border-radius: 0px;
  padding: 5px;
  width: 100%;
  border-bottom: 1px solid #9ccad4;
}

.menu-item:hover{
  color: #fff;
  background: #9ccad4;
  cursor: pointer;
}

.menu-item:focus{
  background: #9ccad4 !important;
}

.scroll-item::-webkit-scrollbar {
   width: 8px;
}

.scroll-item::-webkit-scrollbar-track {
  border-radius: 8px;
    background-color: #d1e7ee;
    border: 1px solid #cacaca;
}

.scroll-item::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px;
  border-color: black;
}

.col-sm-5{
  width: 40%;
  padding-left: 10px;
  padding-right: 5px;
}

.text {
  width: 80%;
  margin: auto;
  color: white;
}

.menu-text {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 10px;
  width: 60%;
  text-align: initial;
  font-size: x-small;
  color: black;
  font-weight: bold;
}

.menu-image{
  margin-left: 5px;
  width: 35px;
  height: 35px;
}

.search-box {
  margin-top: 10px;
  background: #9ccad4;
  padding: 25px 13px;
  border-radius: 10px 10px 0px 0px;
}

.chat-icon{
  font-size:100px;
  color:rgb(156 202 212);

}

</style>

<template>
  
  <div class="row containerchat">

      <div class="col-sm-5">
        <div class="search-box">
            <!-- here will be search box in the future -->
        </div>

        <div class="scroll-item">
          <div  v-for="(menu, index) in responseChatMenu" :key="index" @click="selectItem(index),showContent(menu)">
            <button class="menu-item">
              <img class="menu-image" :src="menu.MenuLogo" alt="">
              <div class="menu-text">{{menu.MenuName}}</div>
              <div class="noti">{{ menu.NewMessageNoti }}</div>
            </button>
          </div>
        </div>
      </div>

      <div class="col-sm-7 message-side" v-if="selectedMenu">

        <div class="settings-tray">
          <img class="profile-image" :src="selectedMenu.MenuLogo" alt="">
          <div class="text">
            <h6>{{ selectedMenu.MenuName }}</h6>
          </div>
        </div>
           
        <div ref="content" class="scrollbar" v-if="selectedMenu.StaffStatus === 0">
          <div v-for="(message, index) in messages" :key="index">
            <div class="left-message" v-if="message.MessageSide === 'Company'">
                <div class="chat-bubble--left">
                  {{ message.MessageBody }}
                  <div class="msg-time--left">{{ message.CreationDateTime }}</div>
                </div>
            </div>
            <div class="right-message" v-if="message.MessageSide === 'Client'">
              <div class="chat-bubble--right">
                  {{ message.MessageBody }}
                  <div class="msg-time--right">{{ message.CreationDateTime }}</div>
              </div>
            </div>
          </div>
        </div>

        <div  ref="content" class="scrollbar" v-if="selectedMenu.StaffStatus === 1">
          <div v-for="(message, index) in messages" :key="index">
            <div class="left-message" v-if="message.MessageSide === 'Client'">
                <div class="chat-bubble--left">
                  {{ message.MessageBody }}
                  <div class="msg-time--left">{{ message.CreationDateTime }}</div>
                </div>
            </div>
            <div class="right-message" v-if="message.MessageSide === 'Company'">
              <div class="chat-bubble--right">
                  {{ message.MessageBody }}
                  <div class="msg-time--right">{{ message.CreationDateTime }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="textarea">
          <textarea name="" class="form-control type_msg" v-model="newMessage" placeholder="Type your message..."></textarea>
          <button class="send_button" @click="sendMessage(selectedMenu)">Send</button>
        </div>

      </div>

      <div v-else class="col-sm-7 message-side" >
        <div class="blank-page">
          <i class="fa fa-comments chat-icon" ></i>
          <h4 style="display:inline-flex; color:rgb(156 202 212);">Start Messagging Now</h4>
        </div>
      </div>

  </div>

</template>

<script>

  import { mapState } from "vuex";
  import Vue from "vue";

  export default {

    data() {
      return {
        selectedMenu: null,
        intervalId: null,
        intervalIdMenu: null,
        selectedIndex: null,
        OldMessage: 0,
        newMessage: "",
        user: JSON.parse(localStorage.getItem("user"))
      };
    },

    mounted() {
      // This code will automatically get menu option (ex list of company available for customer)
      // when component start running
      const getMenu = () => {
        this.$store.dispatch("user/fetchChatMenuSession",{
        FromUserId: this.user.id
        })
      }
      getMenu()

      //for every 30s new set of menu will be fetch including the new msg notification
      this.intervalIdMenu = setInterval(() => {
        getMenu()
        }, 30000);
    },

    beforeDestroy() {

      clearInterval(this.intervalId,this.intervalIdMenu)

    // Perform any necessary cleanup here
     },

    computed: {
      ...mapState("user", ["responseChatMenu"]),
      ...mapState("user", ["messages"]),
      ...mapState("user", ["Id"]),
    },

    methods: {
      // This used to automatically scroll to bottom when the chat session openend
      async showContent(menu) {
        await this.fetchMessage(menu);
        this.selectedMenu = menu;
        this.$nextTick(() => {
          const contentDiv = this.$refs.content;
            contentDiv.scrollTo({
            top: contentDiv.scrollHeight,
            behavior: "smooth" // Smooth scrolling behavior
          });
        });
      },

      // To set selectedIndex and will be monitor through watch method
      selectItem(index) {
        this.selectedIndex = index;
      },

      // Will fetch new message every 3s based on selectedIndex
      startInterval() {
        this.intervalId = setInterval(() => {
          this.fetchMessage(this.selectedMenu)
        }, 3000);
      },

      // Will stop previous selectedIndex Interval
      stopInterval() {
        clearInterval(this.intervalId);
      },

      // Function to fetch new messages and automatically set new message status to read
      async fetchMessage(menu) {
        await this.$store.dispatch("user/fetchMessage", {
          ChatId: menu.ChatId,
          StaffStatus: menu.StaffStatus
          }).then(()=> {
            // If there is new message arrive and the user currently open the related chat session
            // this code will update the status to read and update notification
            // This code is to prevent only after 30 seconds the notification(msg number) will dissapear 
            if(menu.ChatId){
              if(this.OldMessage<Object.keys(this.messages).length){
                this.$store.dispatch("user/fetchChatMenuSession",{
                FromUserId: this.user.id})
                this.showContent(menu);
                }
              this.OldMessage = Object.keys(this.messages).length;
              
              }
            });
            
        },

      // Update session messages if already have chatId or create new one if dont
      async sendMessage(selectedMenu) {
        if(selectedMenu.ChatId != 0) {
          await this.$store.dispatch("user/updateChat", {
              ChatId: this.selectedMenu.ChatId,
              MessageBody: this.newMessage,
              FromUserId: this.user.id,
              StaffStatus: this.selectedMenu.StaffStatus
              });
            this.newMessage = "";
          }
        else {
          await this.$store.dispatch("user/addNewChat", {
            Title: this.selectedMenu.MenuName,
            ToTenantId: this.selectedMenu.MenuId,
            MessageBody: this.newMessage,
            FromUserId: this.user.id
            }).then(()=> {
              selectedMenu.ChatId = this.Id.Id;
            });
          this.newMessage = "";
        }
        this.fetchMessage(selectedMenu);
        this.showContent(selectedMenu);
      }

    },

    watch: {
      // This code will monitor changes in selectedIndex and run code dependinf on consition
      selectedIndex(newIndex, oldIndex) {
        if (oldIndex !== null) {
          this.stopInterval();
         }
        if (newIndex !== null) {
          this.startInterval();
          }
      },
    },

  };

</script>


